import { Component } from '@angular/core';

import { RouterModule } from '@angular/router';
import { AppMenuitem } from '../app.menuitem';

@Component({
  selector: 'app-super-admin-menu',
  standalone: true,
  imports: [AppMenuitem, RouterModule],
  template: `<ul class="layout-menu">
      @for (item of model; track item; let i = $index) {
        @if (!item.separator) {
          <li
            app-menuitem
            [item]="item"
            [index]="i"
            [root]="true"
          ></li>
        }
        @if (item.separator) {
          <li class="menu-separator"></li>
        }
      }
    </ul>`,
})
export class SuperAdminAppMenu {
  model: any[] = [];

  ngOnInit() {
    this.model = [
      // {
      //   label: 'Overview',
      //   icon: 'fa-solid fa-fw fa-house',
      //   items: [
      //     {
      //       label: 'Dashboard',
      //       icon: 'fa-solid fa-fw fa-table-columns',
      //       routerLink: ['/super-admin'],
      //     },
      //   ],
      // },
      // {
      //   label: 'Multi-Course Oversight',
      //   icon: 'fa-solid fa-fw fa-building',
      //   items: [
      //     {
      //       label: 'Courses',
      //       icon: 'fa-solid fa-fw fa-flag',
      //       routerLink: ['/super-admin/courses'],
      //     },
      //   ],
      // },
      {
        label: 'Course Setup & Support',
        icon: 'fa-solid fa-fw fa-screwdriver-wrench',
        items: [
          {
            label: 'Company Setup',
            icon: 'fa-solid fa-fw fa-landmark',
            routerLink: ['/super-admin/companies'],
          },
          {
            label: 'Course Setup',
            icon: 'fa-solid fa-fw fa-gear',
            routerLink: ['/super-admin/course-setup'],
          },
          {
            label: 'Company Employees',
            icon: 'fa-solid fa-fw fa-users',
            routerLink: ['/super-admin/company-employees'],
          },
          {
            label: 'Global Menu',
            icon: 'fa-solid fa-fw fa-book-open',
            routerLink: ['/super-admin/global-menu'],
          },
          // {
          //   label: 'Support',
          //   icon: 'fa-solid fa-fw fa-circle-info',
          //   routerLink: ['/super-admin/support'],
          // },
        ],
      },
      // {
      //   label: 'Billing & Revenue',
      //   icon: 'fa-solid fa-fw fa-wallet',
      //   items: [
      //     {
      //       label: 'Billing',
      //       icon: 'fa-solid fa-fw fa-credit-card',
      //       routerLink: ['/super-admin/billing'],
      //     },
      //   ],
      // },
      // {
      //   label: 'Compliance & Standards',
      //   icon: 'fa-solid fa-fw fa-shield-halved',
      //   items: [
      //     {
      //       label: 'Compliance',
      //       icon: 'fa-solid fa-fw fa-clipboard-check',
      //       routerLink: ['/super-admin/compliance'],
      //     },
      //   ],
      // },
      // {
      //   label: 'Ad Management (Platform)',
      //   icon: 'fa-solid fa-fw fa-bullhorn',
      //   items: [
      //     {
      //       label: 'Platform Ads',
      //       icon: 'fa-solid fa-fw fa-rectangle-ad',
      //       routerLink: ['/super-admin/ads'],
      //     },
      //   ],
      // },
      // {
      //   label: 'Override Controls',
      //   icon: 'fa-solid fa-fw fa-sliders',
      //   items: [
      //     {
      //       label: 'Overrides',
      //       icon: 'fa-solid fa-fw fa-toggle-on',
      //       routerLink: ['/super-admin/overrides'],
      //     },
      //   ],
      // },
      // {
      //   label: 'Reports',
      //   icon: 'fa-solid fa-fw fa-chart-column',
      //   items: [
      //     {
      //       label: 'Overview',
      //       icon: 'fa-solid fa-fw fa-chart-line',
      //       routerLink: ['/super-admin/reports/overview'],
      //     },
      //     {
      //       label: 'Revenue & Billing',
      //       icon: 'fa-solid fa-fw fa-file-invoice-dollar',
      //       routerLink: ['/super-admin/reports/revenue-billing'],
      //     },
      //     {
      //       label: 'Adoption & Engagement',
      //       icon: 'fa-solid fa-fw fa-handshake',
      //       routerLink: ['/super-admin/reports/adoption-engagement'],
      //     },
      //     {
      //       label: 'Customer Experience',
      //       icon: 'fa-solid fa-fw fa-face-smile',
      //       routerLink: ['/super-admin/reports/customer-experience'],
      //     },
      //     {
      //       label: 'Menu & Inventory Trends',
      //       icon: 'fa-solid fa-fw fa-clipboard-list',
      //       routerLink: ['/super-admin/reports/menu-inventory-trends'],
      //     },
      //     {
      //       label: 'Operational Compliance',
      //       icon: 'fa-solid fa-fw fa-user-shield',
      //       routerLink: ['/super-admin/reports/operational-compliance'],
      //     },
      //     {
      //       label: 'Employee Activity',
      //       icon: 'fa-solid fa-fw fa-id-card',
      //       routerLink: ['/super-admin/reports/employee-activity'],
      //     },
      //     {
      //       label: 'Platform Health',
      //       icon: 'fa-solid fa-fw fa-heart-pulse',
      //       routerLink: ['/super-admin/reports/platform-health'],
      //     },
      //     {
      //       label: 'Churn & Retention',
      //       icon: 'fa-solid fa-fw fa-arrow-rotate-right',
      //       routerLink: ['/super-admin/reports/churn-retention'],
      //     },
      //     {
      //       label: 'Support & Escalations',
      //       icon: 'fa-solid fa-fw fa-inbox',
      //       routerLink: ['/super-admin/reports/support-escalations'],
      //     },
      //   ],
      // },
    ];
  }
}
